import { isNil } from "ramda";
import { getMinimumMonthlyPrice } from "../../my-flexi-plan/services/MonthlyFeeCalculator";

export const getProductPrice = product => {
    const isDevicesApp = window.location.pathname
        .toLowerCase()
        .startsWith("/devices");

    if (isDevicesApp) {
        return product.Price;
    }

    const hasMonthlyPrice = isMonthlyPriceProduct(product);
    if (hasMonthlyPrice) {
        return +product.Specifications["Monthly Price"];
    }

    const isDevice = isDeviceProduct(product);
    if (isDevice) {
        return getMinimumMonthlyPrice(product);
    }

    return NaN;
};

export const isDeviceProduct = product =>
    !isNil(product.Specifications?.["Device"]);

export const isMonthlyPriceProduct = product =>
    !isNil(product.Specifications?.["Monthly Price"]);

export const roundAmount = amount => 
    Math.round((amount + Number.EPSILON) * 100) / 100;
